import { useGetTyposQuery } from '../api/v2/typo'
import { useMyContext } from '../context/context'
import useSettingsV2 from './useSettingsV2'

const useTypos = () => {
  const { myContext } = useMyContext()
  const { settings } = useSettingsV2()

  const { data: typos, isLoading } = useGetTyposQuery(myContext)

  return {
    data:
      typos
        ?.filter(f => (f.id ? !settings?.typosV2?.[f.id]?.HIDE : !settings?.FO_MEETING_TYPO_DEFAULT_HIDE))
        .map(m => ({ ...m, label: settings?.[`TYPO_${m.id}_LABEL`] || m.label })) || [],
    isLoading,
  }
}

export default useTypos
